import { __extends, __spreadArrays } from "tslib";
import { fetchFrequentlyAskedQuestions } from '@gn-audio/core/api/knowledge-base';
import { FaqItem } from '../models/faq-item';
import { FaqSpotBaseController } from '../models/faq-spot-base.controller';
import { createFaqFilter } from '../utils/create-faq-filter';
import { prioritizeFaqItems } from '../utils/prioritize-faq-items';
import { sortByQuestion } from '../utils/sort-by-question';
var FaqSpotV2Controller = (function (_super) {
    __extends(FaqSpotV2Controller, _super);
    function FaqSpotV2Controller($scope, $q, productContextService, siteLanguage) {
        var _this = _super.call(this, $scope, productContextService, siteLanguage) || this;
        _this.$scope = $scope;
        _this.$q = $q;
        _this.initialLimit = 5;
        _this.onFaqItemsLoaded = _this.onFaqItemsLoaded.bind(_this);
        return _this;
    }
    FaqSpotV2Controller.prototype.$onInit = function () {
        var _this = this;
        _super.prototype.$onInit.call(this);
        this.initialize();
        this.productContextService
            .subscribe()
            .then(null, null, function (group) {
            if (!group) {
                _this.initialize();
            }
            else {
                var topFaqPromise = fetchFrequentlyAskedQuestions(group.groupId, null, createFaqFilter(group, _this.$scope.limit));
                var allFaqPromise = fetchFrequentlyAskedQuestions(group.groupId);
                _this.$scope.promise = _this.$q.when(Promise.all([topFaqPromise, allFaqPromise]))
                    .then(function (_a) {
                    var topFaqs = _a[0], allFaqs = _a[1];
                    _this.onFaqItemsLoaded(topFaqs, allFaqs);
                });
            }
        });
        this.$scope.showMoreAvailable = function () {
            return _this.$scope.limit < _this.$scope.initialFaqItems.length;
        };
        this.$scope.showAllFaqAvailable = function () {
            return _this.$scope.limit < _this.$scope.initialFaqItems.length;
        };
        this.$scope.searchParametersChanged = function (query, categories) {
            if (query === void 0) { query = ''; }
            if (categories === void 0) { categories = []; }
            _this.$scope.searchQuery = query;
            _this.$scope.showLess();
            var allFaqItems = _this.$scope.allFaqItems;
            if (query) {
                _this.$scope.faqItems = prioritizeFaqItems(allFaqItems, query);
                _this.$scope.initialFaqItems = __spreadArrays(_this.$scope.faqItems);
            }
            else {
                _this.$scope.faqItems = allFaqItems;
                _this.$scope.initialFaqItems = __spreadArrays(_this.$scope.allFaqItems);
            }
            if (categories.length > 0) {
                _this.$scope.faqItems = _this.$scope.faqItems
                    .filter(function (faqItem) {
                    return faqItem.categories && faqItem.categories.some(function (category) { return categories.indexOf(category.key) > -1; });
                });
                if (!query) {
                    _this.$scope.faqItems = sortByQuestion(_this.$scope.faqItems, _this.siteLanguage);
                }
                _this.$scope.initialFaqItems = __spreadArrays(_this.$scope.faqItems);
            }
            _this.$scope.limit = Math.min(_this.$scope.faqItems.length, _this.initialLimit);
            _this.$scope.initialFaqItems = __spreadArrays(_this.$scope.faqItems);
        };
    };
    FaqSpotV2Controller.prototype.initialize = function () {
        this.$scope.initialLimit = this.initialLimit;
        this.$scope.limit = this.initialLimit;
        this.$scope.allFaqItems = [];
        this.$scope.faqItems = [];
        this.$scope.initialFaqItems = [];
    };
    FaqSpotV2Controller.prototype.onFaqItemsLoaded = function (topFaqItems, allFaqItems) {
        this.$scope.allFaqItems = (allFaqItems || []).map(function (x) { return new FaqItem(x); });
        this.$scope.initialFaqItems = __spreadArrays(this.$scope.allFaqItems);
        if (topFaqItems && topFaqItems.length > 0) {
            this.$scope.faqItems = (topFaqItems || []).map(function (x) { return new FaqItem(x); });
        }
        else {
            this.$scope.faqItems = __spreadArrays(this.$scope.initialFaqItems);
        }
        this.$scope.limit = this.$scope.initialLimit;
        this.showMoreAvailable = true;
        this.showAllAvailable = false;
        this.showLessAvailable = false;
    };
    FaqSpotV2Controller.$inject = [
        '$scope',
        '$q',
        'productContextService',
        'siteLanguage',
    ];
    return FaqSpotV2Controller;
}(FaqSpotBaseController));
export { FaqSpotV2Controller };
